import React from 'react';
import { motion } from 'framer-motion';
export function Bonus() {
  const bonuses = [{
    title: 'Calculadora de Ingresos Reales',
    desc: 'Sabés exactamente cuánto estás ganando y cuánto deberías.',
    img: 'https://cdn.magicpatterns.com/uploads/eSLE27MyV9J7xD1sAubpkf/6.png'
  }, {
    title: 'Modelos de Mensajes para Consultorio',
    desc: 'Para cobrar, recordar sesiones y manejar cancelaciones sin incomodidad.',
    img: 'https://cdn.magicpatterns.com/uploads/enHpGdcPLCdsCfhWXVvtQ2/4.png'
  }, {
    title: 'Política de Cancelación Lista para Usar',
    desc: 'Copiás, pegás y la empezás a aplicar hoy mismo.',
    img: 'https://cdn.magicpatterns.com/uploads/nvXvqmCwYDxsaUDbcKtKts/5.png'
  }];
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden" data-id="element-12">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#d4a017]/5 rounded-full blur-3xl pointer-events-none" data-id="element-13"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-bold px-5 py-2 rounded-full text-sm mb-6 uppercase tracking-wide shadow-md animate-pulse" data-id="element-16">
            <span data-id="element-17">🎁</span> BONUS GRATIS HOY
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0f4c5c] mb-6" data-id="element-18">
            HOY TAMBIÉN TE LLEVÁS ESTAS HERRAMIENTAS PRÁCTICAS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-16" data-id="element-19">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center group" data-id="element-20">
              <div className="relative w-full max-w-[280px] aspect-[3/4] mb-6 flex items-center justify-center" data-id="element-21">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#0f4c5c]/10 to-transparent rounded-2xl transform -rotate-3 group-hover:rotate-0 transition-transform duration-300" data-id="element-22"></div>
                <img src={bonus.img} alt={bonus.title} className="relative z-10 w-full h-auto object-contain drop-shadow-xl group-hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={scrollToCompra} data-id="element-23" />
              </div>
              <h3 className="text-xl font-bold text-[#0f4c5c] mb-3" data-id="element-24">
                {bonus.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-25">{bonus.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center bg-[#0f4c5c] text-white py-6 px-8 rounded-2xl shadow-xl max-w-3xl mx-auto border-2 border-[#d4a017]" data-id="element-26">
          <p className="text-2xl md:text-3xl font-bold uppercase tracking-wide" data-id="element-27">
            👉 TODO INCLUIDO SIN COSTO ADICIONAL
          </p>
        </motion.div>
      </div>
    </section>;
}